import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TokenState } from '../reducers/token.reducer';

// Feature selector
export const selectTokenState = createFeatureSelector<TokenState>('token');

// Get token value
export const selectToken = createSelector(
  selectTokenState,
  (state) => state.token
);

// Boolean check
export const isAuthenticated = createSelector(
  selectToken,
  (token) => !!token
);
